// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3UI1k","productName":"Table_productName__3WPt3"};